module.exports = __webpack_public_path__ + "static/heli_centre-ba761de1b20ee659d49bb02ac5e5709e.png";